export default "__VITE_ASSET__CdcPoRCl__"